export const getErrors = (errors, dayName, index, field) => {
  if (!errors) return "";
  if (!errors[dayName]) return "";
  if (!errors[dayName]["slots"][index]) return "";
  if (!errors[dayName]["slots"][index][field]) return "";
  return true;
};

export const days = [
  { name: "Sunday", short: "S", index: 0 },
  { name: "Monday", short: "M", index: 1 },
  { name: "Tuesday", short: "T", index: 2 },
  { name: "Wednesday", short: "W", index: 3 },
  { name: "Thursday", short: "T", index: 4 },
  { name: "Friday", short: "F", index: 5 },
  { name: "Saturday", short: "S", index: 6 },
];

export const gdePermissionOpts = [
  {label:'View All Jobs', value:'viewAllJobs', enabled:false, role:'Data Entry'},
  {label:'Assign Job', value:'assignJob', enabled:false, role:'Data Entry'},
  {label:'Quality Check', value:'qualityCheck', enabled:false, role:'Data Entry'},
  {label:'Manually Transmit Job', value:'manuallyTransmitJob', enabled:false, role:'Data Entry'},
  {label:'View Productivity Reports', value:'viewProductivityReport', enabled:false, role:'Data Entry'}, 
  {label:'Require Quality Check', value:'requireQualityCheck', enabled:false, role:'Data Entry'},
  {label:'Search Template', value:'searchTemplate', enabled:false, role:'Data Entry'},
  {label:'Create Job', value:'createJob', enabled:false, role:'Data Entry'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role: 'Data Entry'},
  {label:'Edit/Cancel Job', value:'editJob', enabled:false, role:'Supervisor'},
  {label:'Create Template', value:'createTemplate', enabled:false, role:'Supervisor'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Supervisor'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Admin'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Super User'},
  {label:'Delete Box', value: 'deleteBox', enabled: false, role: 'Admin'}
]

export const mealDuration = [
  "30 mins",
  "45 mins",
  "60 mins",
  "90 mins",
  "120 mins",
];
export const hoursPerDayDuration = [
  "0 Hour",
  "0.5 Hours",
  "1 Hour",
  "1.5 Hours",
  "2 Hours",
  "2.5 Hours",
  "3 Hours",
  "3.5 Hours",
  "4 Hours",
  "4.5 Hours",
  "5 Hours",
  "5.5 Hours",
  "6 Hours",
  "6.5 Hours",
  "7 Hours",
  "7.5 Hours",
  "8 Hours",
  "8.5 Hours",
  "9 Hours",
  "9.5 Hours",
  "10 Hours",
  "10.5 Hours",
  "11 Hours",
  "11.5 Hours",
  "12 Hours",
];

export const hoursPerWeekDuration = [
  "0 Hour",
  "1 Hour",
  "2 Hours",
  "3 Hours",
  "4 Hours",
  "5 Hours",
  "6 Hours",
  "7 Hours",
  "8 Hours",
  "9 Hours",
  "10 Hours",
  "11 Hours",
  "12 Hours",
  "13 Hours",
  "14 Hours",
  "15 Hours",
  "16 Hours",
  "17 Hours",
  "18 Hours",
  "19 Hours",
  "20 Hours",
  "21 Hours",
  "22 Hours",
  "23 Hours",
  "24 Hours",
  "25 Hours",
  "26 Hours",
  "27 Hours",
  "28 Hours",
  "29 Hours",
  "30 Hours",
  "31 Hours",
  "32 Hours",
  "33 Hours",
  "34 Hours",
  "35 Hours",
  "36 Hours",
  "37 Hours",
  "38 Hours",
  "39 Hours",
  "40 Hours",
  "41 Hours",
  "42 Hours",
  "43 Hours",
  "44 Hours",
  "45 Hours",
  "46 Hours",
  "47 Hours",
  "48 Hours",
  "49 Hours",
  "50 Hours",
  "51 Hours",
  "52 Hours",
  "53 Hours",
  "54 Hours",
  "55 Hours",
  "56 Hours",
  "57 Hours",
  "58 Hours",
  "59 Hours",
  "60 Hours",
 
];

export const times = [
  "00:00am",
  "00:05am",
  "00:10am",
  "00:15am",
  "00:20am",
  "00:25am",
  "00:30am",
  "00:35am",
  "00:40am",
  "00:45am",
  "00:50am",
  "00:55am",
  "01:00am",
  "01:05am",
  "01:10am",
  "01:15am",
  "01:20am",
  "01:25am",
  "01:30am",
  "01:35am",
  "01:40am",
  "01:45am",
  "01:50am",
  "01:55am",
  "02:00am",
  "02:05am",
  "02:10am",
  "02:15am",
  "02:20am",
  "02:25am",
  "02:30am",
  "02:35am",
  "02:40am",
  "02:45am",
  "02:50am",
  "02:55am",
  "03:00am",
  "03:05am",
  "03:10am",
  "03:15am",
  "03:20am",
  "03:25am",
  "03:30am",
  "03:35am",
  "03:40am",
  "03:45am",
  "03:50am",
  "03:55am",
  "04:00am",
  "04:05am",
  "04:10am",
  "04:15am",
  "04:20am",
  "04:25am",
  "04:30am",
  "04:35am",
  "04:40am",
  "04:45am",
  "04:50am",
  "04:55am",
  "05:00am",
  "05:05am",
  "05:10am",
  "05:15am",
  "05:20am",
  "05:25am",
  "05:30am",
  "05:35am",
  "05:40am",
  "05:45am",
  "05:50am",
  "05:55am",
  "06:00am",
  "06:05am",
  "06:10am",
  "06:15am",
  "06:20am",
  "06:25am",
  "06:30am",
  "06:35am",
  "06:40am",
  "06:45am",
  "06:50am",
  "06:55am",
  "07:00am",
  "07:05am",
  "07:10am",
  "07:15am",
  "07:20am",
  "07:25am",
  "07:30am",
  "07:35am",
  "07:40am",
  "07:45am",
  "07:50am",
  "07:55am",
  "08:00am",
  "08:05am",
  "08:10am",
  "08:15am",
  "08:20am",
  "08:25am",
  "08:30am",
  "08:35am",
  "08:40am",
  "08:45am",
  "08:50am",
  "08:55am",
  "09:00am",
  "09:05am",
  "09:10am",
  "09:15am",
  "09:20am",
  "09:25am",
  "09:30am",
  "09:35am",
  "09:40am",
  "09:45am",
  "09:50am",
  "09:55am",
  "10:00am",
  "10:05am",
  "10:10am",
  "10:15am",
  "10:20am",
  "10:25am",
  "10:30am",
  "10:35am",
  "10:40am",
  "10:45am",
  "10:50am",
  "10:55am",
  "11:00am",
  "11:05am",
  "11:10am",
  "11:15am",
  "11:20am",
  "11:25am",
  "11:30am",
  "11:35am",
  "11:40am",
  "11:45am",
  "11:50am",
  "11:55am",
  "00:00pm",
  "00:05pm",
  "00:10pm",
  "00:15pm",
  "00:20pm",
  "00:25pm",
  "00:30pm",
  "00:35pm",
  "00:40pm",
  "00:45pm",
  "00:50pm",
  "00:55pm",
  "01:00pm",
  "01:05pm",
  "01:10pm",
  "01:15pm",
  "01:20pm",
  "01:25pm",
  "01:30pm",
  "01:35pm",
  "01:40pm",
  "01:45pm",
  "01:50pm",
  "01:55pm",
  "02:00pm",
  "02:05pm",
  "02:10pm",
  "02:15pm",
  "02:20pm",
  "02:25pm",
  "02:30pm",
  "02:35pm",
  "02:40pm",
  "02:45pm",
  "02:50pm",
  "02:55pm",
  "03:00pm",
  "03:05pm",
  "03:10pm",
  "03:15pm",
  "03:20pm",
  "03:25pm",
  "03:30pm",
  "03:35pm",
  "03:40pm",
  "03:45pm",
  "03:50pm",
  "03:55pm",
  "04:00pm",
  "04:05pm",
  "04:10pm",
  "04:15pm",
  "04:20pm",
  "04:25pm",
  "04:30pm",
  "04:35pm",
  "04:40pm",
  "04:45pm",
  "04:50pm",
  "04:55pm",
  "05:00pm",
  "05:05pm",
  "05:10pm",
  "05:15pm",
  "05:20pm",
  "05:25pm",
  "05:30pm",
  "05:35pm",
  "05:40pm",
  "05:45pm",
  "05:50pm",
  "05:55pm",
  "06:00pm",
  "06:05pm",
  "06:10pm",
  "06:15pm",
  "06:20pm",
  "06:25pm",
  "06:30pm",
  "06:35pm",
  "06:40pm",
  "06:45pm",
  "06:50pm",
  "06:55pm",
  "07:00pm",
  "07:05pm",
  "07:10pm",
  "07:15pm",
  "07:20pm",
  "07:25pm",
  "07:30pm",
  "07:35pm",
  "07:40pm",
  "07:45pm",
  "07:50pm",
  "07:55pm",
  "08:00pm",
  "08:05pm",
  "08:10pm",
  "08:15pm",
  "08:20pm",
  "08:25pm",
  "08:30pm",
  "08:35pm",
  "08:40pm",
  "08:45pm",
  "08:50pm",
  "08:55pm",
  "09:00pm",
  "09:05pm",
  "09:10pm",
  "09:15pm",
  "09:20pm",
  "09:25pm",
  "09:30pm",
  "09:35pm",
  "09:40pm",
  "09:45pm",
  "09:50pm",
  "09:55pm",
  "10:00pm",
  "10:05pm",
  "10:10pm",
  "10:15pm",
  "10:20pm",
  "10:25pm",
  "10:30pm",
  "10:35pm",
  "10:40pm",
  "10:45pm",
  "10:50pm",
  "10:55pm",
  "11:00pm",
  "11:05pm",
  "11:10pm",
  "11:15pm",
  "11:20pm",
  "11:25pm",
  "11:30pm",
  "11:35pm",
  "11:40pm",
  "11:45pm",
  "11:50pm",
  "11:55pm",
];

//options available for report view
export const optionsAvailable = ["Weekly", "Monthly"];
